import { IGeoLocationData } from  "@/interfaces/passkeys";

export function formatLocation(location: IGeoLocationData): string | null {
  const { city, country } = location;

  if (city && country) {
    return `${city}, ${country}`;
  }

  if (country) {
    return country;
  }

  return null;
}